const API_BASE = process.env.REACT_APP_API_URL || 'https://YOUR_API_GATEWAY_ID.execute-api.us-east-1.amazonaws.com/v1';

function getToken() {
  return localStorage.getItem('ts_token');
}

async function request(method, path, body = null) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : null
  });

  const data = await res.json();
  if (!res.ok) throw { status: res.status, ...data };
  return data;
}

// Auth
export const register = (body) => request('POST', '/vendor/register', body);
export const login = (body) => request('POST', '/vendor/login', body);
export const getProfile = () => request('GET', '/vendor/me');
export const updateProfile = (body) => request('PUT', '/vendor/me', body);

// Catalog
export const listItems = () => request('GET', '/vendor/catalog');
export const createItem = (body) => request('POST', '/vendor/catalog', body);
export const getItem = (itemId) => request('GET', `/vendor/catalog/${itemId}`);
export const updateItem = (itemId, body) => request('PUT', `/vendor/catalog/${itemId}`, body);
export const deleteItem = (itemId) => request('DELETE', `/vendor/catalog/${itemId}`);

// Images
export const getUploadUrl = (itemId, fileName, contentType) =>
  request('POST', `/vendor/catalog/${itemId}/images`, { fileName, contentType });

// Stripe Connect
export const createStripeConnect = () => request('POST', '/vendor/stripe/connect');
export const getStripeStatus = () => request('GET', '/vendor/stripe/status');

// Spotlight Bid
export const getActiveSpotlight = () => request('GET', '/spotlight/active');
export const getSpotlightBids = () => request('GET', '/spotlight/active/bids');
export const getSpotlightHistory = () => request('GET', '/spotlight/history');
export const placeSpotlightBid = (amount) => customerRequest('POST', '/spotlight/active/bid', { amount });

// Subscription
export const createSubscriptionCheckout = (tier) => customerRequest('POST', '/subscription/checkout', { tier });
export const getSubscriptionStatus = () => customerRequest('GET', '/subscription/status');
export const openSubscriptionPortal = () => customerRequest('POST', '/subscription/portal');

// Purchase
export const purchaseItem = (vendorId, itemId, tip = 0) => customerRequest('POST', '/purchase/checkout', { vendorId, itemId, tip });

// Orders
export const getVendorOrders = () => request('GET', '/vendor/orders');
export const markOrderShipped = (orderId, trackingNumber, trackingCarrier) => request('PUT', `/vendor/orders/${orderId}/ship`, { trackingNumber, trackingCarrier });
export const respondToCancel = (orderId, action) => request('PUT', `/vendor/orders/${orderId}/cancel-respond`, { action });
export const getCustomerOrders = () => customerRequest('GET', '/customer/orders');
export const requestCancelOrder = (orderId) => customerRequest('POST', `/customer/orders/${orderId}/cancel`);

// Workshop
export const getBlueprints = () => request('GET', '/workshop/blueprints');
export const getBlueprint = (id) => request('GET', `/workshop/blueprints/${id}`);
export const getVendorBlueprints = () => request('GET', '/vendor/blueprints');
export const createBlueprint = (body) => request('POST', '/vendor/blueprints', body);
export const updateBlueprint = (id, body) => request('PUT', `/vendor/blueprints/${id}`, body);
export const publishVersion = (id, body) => request('POST', `/vendor/blueprints/${id}/version`, body);
export const forkBlueprint = (id, body) => {
  const token = localStorage.getItem('ts_token') || localStorage.getItem('ts_customer_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return fetch(`${API_BASE}/workshop/blueprints/${id}/fork`, { method: 'POST', headers, body: JSON.stringify(body) })
    .then(async res => { const data = await res.json(); if (!res.ok) throw data; return data; });
};
export const getShopResults = (id) => request('GET', `/workshop/blueprints/${id}/results`);
export const postShopResult = (id, body) => customerRequest('POST', `/workshop/blueprints/${id}/results`, body);
export const getContributions = () => request('GET', '/workshop/contributions');
export const purchaseBlueprint = (id) => customerRequest('POST', `/workshop/blueprints/${id}/purchase`);
export const saveBlueprintApi = (id) => {
  const token = localStorage.getItem('ts_token') || localStorage.getItem('ts_customer_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return fetch(`${API_BASE}/workshop/blueprints/${id}/save`, { method: 'POST', headers })
    .then(async res => { const data = await res.json(); if (!res.ok) throw data; return data; });
};
export const unsaveBlueprintApi = (id) => {
  const token = localStorage.getItem('ts_token') || localStorage.getItem('ts_customer_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return fetch(`${API_BASE}/workshop/blueprints/${id}/save`, { method: 'DELETE', headers })
    .then(async res => { const data = await res.json(); if (!res.ok) throw data; return data; });
};
export const getSavedBlueprints = () => {
  const token = localStorage.getItem('ts_token') || localStorage.getItem('ts_customer_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return fetch(`${API_BASE}/workshop/saves`, { method: 'GET', headers })
    .then(async res => { const data = await res.json(); if (!res.ok) throw data; return data; });
};

// Public
export const getPublicVendors = () => request('GET', '/public/vendors');
export const getVendorBooth = (vendorId) => request('GET', `/public/vendors/${vendorId}`);

// Customer Auth
function customerRequest(method, path, body = null) {
  const headers = { 'Content-Type': 'application/json' };
  const token = localStorage.getItem('ts_customer_token');
  if (token) headers['Authorization'] = `Bearer ${token}`;

  return fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : null
  }).then(async res => {
    const data = await res.json();
    if (!res.ok) throw { status: res.status, ...data };
    return data;
  });
}

export const customerRegister = (body) => customerRequest('POST', '/customer/register', body);
export const customerLogin = (body) => customerRequest('POST', '/customer/login', body);
export const getCustomerProfile = () => customerRequest('GET', '/customer/me');
export const listCommissions = () => customerRequest('GET', '/customer/commissions');
export const createCommission = (body) => customerRequest('POST', '/customer/commissions', body);
export const getCommission = (id) => customerRequest('GET', `/customer/commissions/${id}`);
export const deleteCommission = (id) => customerRequest('DELETE', `/customer/commissions/${id}`);

// Commission Pitches
export const getOpenCommissions = () => request('GET', '/commissions/open');
export const submitPitch = (commissionId, body) => request('POST', `/commissions/${commissionId}/pitch`, body);
export const getPitches = (commissionId) => customerRequest('GET', `/commissions/${commissionId}/pitches`);
export const acceptPitch = (commissionId, pitchId) => customerRequest('PUT', `/commissions/${commissionId}/accept`, { pitchId });
export const getVendorPitches = () => request('GET', '/vendor/pitches');

// Offers
export const getCustomerOffers = () => customerRequest('GET', '/customer/offers');
export const createOffer = (body) => customerRequest('POST', '/customer/offers', body);
export const offerCheckout = (offerId) => customerRequest('POST', `/customer/offers/${offerId}/checkout`);
export const getVendorOffers = () => request('GET', '/vendor/offers');
export const respondToOffer = (offerId, action) => request('PUT', `/vendor/offers/${offerId}/respond`, { action });

// Vendor Subscription
export const vendorSubscriptionCheckout = (tier) => request('POST', '/vendor/subscription/checkout', { tier });
export const getVendorSubscriptionStatus = () => request('GET', '/vendor/subscription/status');
export const vendorSubscriptionPortal = () => request('POST', '/vendor/subscription/portal');
export const redeemVendorVoucher = (code) => request('POST', '/vendor/subscription/redeem', { code });
